import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { generateResolveSelectFieldsSource } from '@next-adapter/generators/actions/select-fields-resolver.js'

export function generateResolveSelectFieldsFunction(ctx: EntityCtx): string {
  return generateResolveSelectFieldsSource({
    Singular: ctx.Singular,
    selectFields: ctx.selectFields,
    selectOptionsTableVar: ctx.selectOptionsTableVar,
    hasCreatableSelectFields: ctx.hasCreatableSelectFields,
    exported: true
  })
}
